<template>
  <div class="main">
    <div class="header">
      <i class="el-icon-s-fold" v-if="!isCollapse" @click="fold"></i>
      <i class="el-icon-s-unfold" @click="fold" v-else></i>
      <el-dropdown split-button type="primary" trigger='click' :hide-on-click='false' class="user-dropdown right-dropdown account-info">
        <span class="el-dropdown-link">
          <div>{{changeToStar(teamName, 4, 3, 3, 8) || userName}}</div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if='!loginInfos.length'>切换团队</el-dropdown-item>
          <el-dropdown-item v-else>
            <el-dropdown placement='right-start' :hide-on-click="false">
              <span class="dropdown-link">
                切换团队<i class="el-icon-arrow-right el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" :class="{'height-style': teams.length > 7}">
                <el-dropdown-item>
                  <el-input placeholder="请输入名称" v-model="filterValue" class="search" ref="search" prefix-icon="el-icon-search" @input="filterChange" clearable :autofocus="true"></el-input>
                </el-dropdown-item>
                <template>
                  <el-dropdown-item v-for='(element, index) in teams' :key="index" :divided="index > 0" :disabled="backSuccess">
                    <span @click="preserve(element)" :class="{'dropdown-link': true, 'special': element.agentCode === accountAgentCode}">
                      {{changeToStar(element.abbreviation, 6, 5, 3, 12) || element.fullName || element.name}}
                      <div class="label">{{element.teamRole === 1 ? '创建者' : element.teamRole === 2 ? '管理员' : '普通成员'}}</div>
                      <i v-if="element.agentCode === accountAgentCode" class="el-icon-check check"></i>
                    </span>
                  </el-dropdown-item>
                </template>
              </el-dropdown-menu>
            </el-dropdown>
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="signOut" class="sign-out dropdown-link">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span class="help-doc">
        <el-tooltip class="item" effect="dark" content="点击问号查看帮助文档" placement="bottom">
          <i @click="toHelpDoc"><img width="100%" src="//img.pipacoding.com/assets/fe-agent-client/icon-question.png"></i>
        </el-tooltip>
      </span>
      <span class="mini-qrcode">
        <el-popover
          placement="bottom"
          width="200"
          trigger="hover">
          <div class="qrcode">
            <h4 :style="{paddingBottom: '10px', textAlign: 'center'}">微信扫描进入繁星联盟小程序</h4>
            <p><img width="100%" src="//img.pipacoding.com/assets/fe-agent-client/gh_5fac0d72a597_258.jpg"></p>
          </div>
          <i slot="reference"><img width="100%" src="//img.pipacoding.com/assets/fe-agent-client/icon-mini.png"></i>
        </el-popover>
      </span>
    </div>
    <div class="content">
      <router-view :key="key" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  removeToken, removeTeamCode, removeAgentCode, getAgentCode,
  removeTeamName
} from '@/utils/auth';
import { delUndefined } from "@/utils/utils";
import { getAccountInfo, changeTeam } from '@/services/user'
import Cookie from 'js-cookie';

export default {
  name: 'appMain',
  props: ['isCollapse'],
  inject: ['reload'],
  data() {
    return {
      userName: this.$store.state.staff && this.$store.state.staff.name,
      userId: this.$store.state.staff && this.$store.state.staff.id,
      teamName: this.$store.state.staff && this.$store.state.staff.teamName,
      id: this.$store.state.user && this.$store.state.user.id,
      staffId: '',
      staffName: '',
      title: 'made',
      filterValue: '',
      backSuccess: false,
      teams: [],
    }
  },
  computed: {
    ...mapGetters(['loginInfos']),
    key () {
      return this.$route.path
    },
    accountAgentCode() {
      return getAgentCode()
    },
  },
  created () {
    this.filterChange()
  },
  mounted() {
    if (this.id) {
      getAccountInfo(this.id).then(response => {
        if (response.data && response.data.errCode === 0) {
          const result = response.data.data
          this.staffId = result.id;
          this.staffName = result.nickname;
        }
      })
    }
  },
  methods: {
    changeToStar(str = '', len1, len2, len3, allLong) {
      const strLen = str ? str.length : 0;
      let stars = '';
      for (let i = 0; i < len3; i++) { stars += '*' }
      const strNew = str.substr(0, len1) + stars + str.substr(strLen - len2)
      return strLen > allLong ? strNew : str
    },
    filterChange(value) {
      const { loginInfos } = this;
      let list = [];
      if (value) {
        list = loginInfos.filter(item => {
          const { abbreviation, fullName, name } = item;
          const nameText = abbreviation || fullName || name;
          const v = new RegExp(value);
          return v.test(nameText);
        })
      } else {
        list = loginInfos;
      }
      this.teams = list;
    },
    fold() {
      this.$emit('fold')
    },
    // 切换团队
    preserve(preserve) {
      this.backSuccess = true;
      const params = {
        agentCode: preserve.agentCode || null,
        teamCode: preserve.teamCode || null
      }
      changeTeam(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          const accountInfo = res.data.data;
          if (Number(accountInfo.agentStatus !== 0) || Number(accountInfo.teamStatus !== 0)) {
            this.backSuccess = false;
            this.$notify.error({
              title: `团队「${accountInfo.abbreviation || accountInfo.fullName || ''}」已将你账号停用`,
            });
          } else {
            const expiresTime = { expires: 9 }
            localStorage.setItem("loginInfos", JSON.stringify(accountInfo.loginInfos || '') || []);
            this.userName = accountInfo.name || accountInfo.fullName || '';
            this.userId = accountInfo.agentCode || null;
            Cookie.set('teamName', accountInfo.abbreviation || accountInfo.fullName || '', expiresTime)
            Cookie.set('agentCode', accountInfo.agentCode || '', expiresTime)
            Cookie.set('agentName', accountInfo.name || '', expiresTime)
            Cookie.set('agentStatus', accountInfo.agentStatus || '', expiresTime)
            Cookie.set('teamCode', accountInfo.teamCode || '', expiresTime)
            Cookie.set('teamType', accountInfo.teamType || '', expiresTime)
            Cookie.set('teamRole', accountInfo.teamRole || '', expiresTime)
            Cookie.set('teamStatus', accountInfo.teamStatus || '', expiresTime)
            Cookie.set('conversionPath', accountInfo.conversionPath || null, expiresTime)
            window.location.href = `${window.location.origin}`
          }
        } else {
          this.backSuccess = false;
          this.$notify.error({
            title: '消息',
            message: res.data.errMsg || '切换团队失败'
          });
        }
      })
    },
    signOut () {
      removeAgentCode()
      removeTeamCode()
      removeToken()
      removeTeamName()
      this.$router.push({ path: '/login' })
    },
    toHelpDoc () {
      window.open('https://ug.hetao101.com/FXNLIg1F')
    }
  }
}
</script>

<style scoped lang="less">
.main {
  .header{
    .mini-qrcode, .help-doc{
      float: right;
      margin: 18px 15px 0;
      i{
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 10px;
      }
    }
  }
  .content {
    position: relative;
    margin: 10px;
    padding: 10px;
    background-color: #fff;
    border-radius: 5px;
  }
  .input-style{
    display: inline-block;
    width: 370px;
    margin: 0 auto;
    text-align: center;
  }
  .line {
    width: 100%;
    height: 1px;
    background-color: #ddd;
    margin-top: -30px;
    margin-bottom: 30px;
  }
  .sign-out{
    width: 90px;
    display: block;
  }
}
</style>
